module.exports = __webpack_public_path__ + "img/7815.e6d22349.svg";